
module.exports = function envJudge () {
  if (process.env.VUE_APP_BASE_API.includes('dev')) {
    return '/dev/';
  } else if (process.env.VUE_APP_BASE_API.includes('test')) {
    return '/test/';
  } else if (process.env.VUE_APP_BASE_API.includes('rc')) {
    return '/rc/';
  } else {
    return '/';
  }
};
